import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import FlexRow from "../components/FlexRow";
import Card from "../components/Card";
import ShadowImage from "../components/ShadowImage";
import montreal from "../images/us-montreal.jpg";
import pikesPeak from "../images/us-pikes-peak.jpg";

const CenterContent = styled.div`
  margin-top: 1.5rem;

  text-align: center;

  p {
    font-size: 1.3rem;
  }
`;

const RowItem = styled.div`
  flex: 1;

  margin: 0.5rem;
`;

const SizedImage = ShadowImage.extend`
  width: 30rem;
`;

const IndexPage = () => (
  <div>
    <Card header="Will You Celebrate Our Love With Us?">
      <CenterContent>
        <SizedImage src={montreal} />
        <p>
          We invite you to join us
          <br />
          in celebrating our love.
          <br />
          <br />
          On this day we will marry the one
          <br />
          we laugh with, live for, dream with, love.
          <br />
          <br />
          We have chosen to continue
          <br />
          our growth through marriage.
          <br />
          <br />
          Please join
          <br />
          <strong>Adam Michael Fishman</strong>
          <br />
          and
          <br />
          <strong>Casey Todd Lee</strong>
          <br />
          <br />
          Saturday the eighteenth of August
          <br />
          two thousand eighteen
          <br />
          at ten thirty in the morning.
          <br />
          <br />
          Hilton Denver Inverness
          <br />
          200 Inverness Drive West
          <br />
          Englewood, Colorado
          <br />
          <br />
          Formal attire
          <br />
          <br />
          RSVP by Sunday the fifteenth of July.
        </p>
        <SizedImage src={pikesPeak} />
      </CenterContent>
    </Card>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js